(function () {
  'use strict';

  function init(section) {
    // Cada paso incluye este mismo script, así que en una página con 5 pasos se ejecuta 5 veces.
    // Sin esta marca cada radio terminaría con 5 listeners duplicados.
    if (section.dataset.bmStepReady === 'true') return;
    section.dataset.bmStepReady = 'true';

    var variantInputs = section.querySelectorAll('[data-bm-variant-option]');
    var addonInputs = section.querySelectorAll('[data-bm-addon-choice]');
    var stepImages = section.querySelectorAll('[data-bm-step-image]');
    var fallbackImage = section.querySelector('[data-bm-step-fallback]');

    // Muestra la foto correspondiente al valor elegido (ej. la foto azul al elegir "Azul").
    // Si esa variante no tiene foto asignada en el admin, cae al respaldo del editor de temas.
    function showImageForValue(value) {
      if (!stepImages.length) return;
      var matched = false;
      stepImages.forEach(function (slot) {
        var isMatch = slot.dataset.value === value;
        slot.classList.toggle('is-active', isMatch);
        if (isMatch) matched = true;
      });
      if (fallbackImage) fallbackImage.classList.toggle('is-active', !matched);
    }

    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        showImageForValue(input.value);
        document.dispatchEvent(
          new CustomEvent('bm:variant-option-change', {
            detail: {
              optionIndex: parseInt(input.dataset.optionIndex, 10),
              value: input.value
            }
          })
        );
      });
    });

    // Los "extras" (Batería, SIM) no cambian la variante real: solo emiten un evento
    // para que una app de opciones de producto pueda escucharlo y ajustar el precio final.
    addonInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        document.dispatchEvent(
          new CustomEvent('backmarket:addon-change', {
            detail: {
              group: input.closest('[data-bm-addon-group]').dataset.bmAddonGroup,
              value: input.value,
              priceAdjustment: input.dataset.priceAdjustment
            }
          })
        );
      });
    });

    // Estado inicial: deja visible la foto del valor ya marcado al cargar la página.
    var checked = section.querySelector('[data-bm-variant-option]:checked');
    if (checked) showImageForValue(checked.value);
  }

  document.querySelectorAll('[data-bm-step-section]').forEach(init);

  // Renumera los rotulos "PASO x DE y" segun el orden en que se ven en la
  // pagina. Liquid solo conoce el orden de las opciones del producto, que no
  // tiene por que coincidir con el orden de las secciones: en el Redmi, el
  // almacenamiento va primero en pantalla pero es la segunda opcion.
  function renumerarPasos() {
    var rotulos = [];
    document.querySelectorAll('[data-bm-step-section] .bm-step__label').forEach(function (el) {
      if (/^PASO\s+\d+\s+DE\s+\d+$/i.test(el.textContent.trim())) rotulos.push(el);
    });
    rotulos.forEach(function (el, i) {
      el.textContent = 'PASO ' + (i + 1) + ' DE ' + rotulos.length;
    });
  }
  renumerarPasos();
})();